import { Shield, Clock, Eye, AlertTriangle, ChevronUp, ChevronDown } from 'lucide-react';
import { useState } from 'react';

const ProctorDashboard = ({ metrics, integrityScore, violations }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const formatTime = (ms) => {
    const minutes = Math.floor(ms / 60000);
    const seconds = Math.floor((ms % 60000) / 1000);
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  };

  const getScoreColor = (score) => {
    if (score >= 80) return 'text-green-600';
    if (score >= 60) return 'text-yellow-600';
    return 'text-red-600';
  };

  return (
    <div className="fixed bottom-2 right-2 md:bottom-4 md:right-4 z-50">
      <div className="bg-white rounded-lg shadow-lg border p-2 md:p-4 w-48 md:w-64">
        <div 
          className="flex items-center justify-between cursor-pointer md:cursor-default"
          onClick={() => setIsExpanded(!isExpanded)}
        >
          <h3 className="text-xs md:text-sm font-semibold text-gray-800 flex items-center gap-1 md:gap-2">
            <Shield size={14} className="md:w-4 md:h-4" />
            <span className="hidden md:inline">Integrity Monitor</span>
            <span className="md:hidden">Integrity</span>
          </h3>
          <div className="flex items-center gap-2">
            <span className={`text-sm md:text-lg font-bold ${getScoreColor(integrityScore)}`}>
              {integrityScore}%
            </span>
            <button className="md:hidden">
              {isExpanded ? <ChevronDown size={16} /> : <ChevronUp size={16} />}
            </button>
          </div>
        </div>

        <div className={`${isExpanded ? 'block' : 'hidden'} md:block mt-2 md:mt-3 space-y-1.5 md:space-y-2`}>
          <div className="flex items-center justify-between text-[10px] md:text-xs">
            <span className="text-gray-600 flex items-center gap-1">
              <Clock size={10} className="md:w-3 md:h-3" />
              Time
            </span>
            <span className="font-medium">
              {formatTime(Date.now() - metrics.startTime)}
            </span>
          </div>

          <div className="flex items-center justify-between text-[10px] md:text-xs">
            <span className="text-gray-600 flex items-center gap-1">
              <Eye size={10} className="md:w-3 md:h-3" />
              Switches
            </span>
            <span className={`font-medium ${metrics.tabSwitches > 3 ? 'text-red-600' : 'text-gray-800'}`}>
              {metrics.tabSwitches}
            </span>
          </div>

          <div className="flex items-center justify-between text-[10px] md:text-xs">
            <span className="text-gray-600">Rapid</span>
            <span className={`font-medium ${metrics.rapidAnswers > 5 ? 'text-red-600' : 'text-gray-800'}`}>
              {metrics.rapidAnswers}
            </span>
          </div>

          <div className="flex items-center justify-between text-[10px] md:text-xs">
            <span className="text-gray-600 flex items-center gap-1">
              <AlertTriangle size={10} className="md:w-3 md:h-3" />
              Violations
            </span>
            <span className={`font-medium ${violations.total > 0 ? 'text-red-600' : 'text-green-600'}`}>
              {violations.total}
            </span>
          </div>
        </div>

        {violations.total > 0 && (isExpanded || typeof window !== 'undefined' && window.innerWidth >= 768) && (
          <div className="mt-2 md:mt-3 pt-2 md:pt-3 border-t">
            <div className="flex justify-between text-[10px] md:text-xs">
              <span className="text-red-600">H: {violations.high}</span>
              <span className="text-yellow-600">M: {violations.medium}</span>
              <span className="text-gray-600">L: {violations.low}</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProctorDashboard;
